/**
 * Guard preview → form selection sync.
 * While a query key transition clears cached rows, syncing `[]` would wipe
 * `selectedRecipientPhones` and change the key again (infinite refetch).
 */
export function canSyncPreviewSelection(state: {
  shouldFetch: boolean;
  isLoading: boolean;
  isFetching: boolean;
  hasError: boolean;
}): boolean {
  return state.shouldFetch && !state.isLoading && !state.isFetching && !state.hasError;
}
